import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import useTranslate from '../../../../../../customHooks/useTranslate';
import { useZitoneoActivityLogs } from '../../../../contexts/ZitoneoContentContext';
import { useZitoneoUI } from '../../../../contexts/ZitoneoUIContext';
import { ZitoneoViewMode } from '../../../../types/zitoneoServicesTypes';
import Button from '../../../../../../muiComponents/Button';
import ConnectivityLogsStatusBadge from './ConnectivityLogsStatusBadge';
import ConnectivityLogsInfoText from './ConnectivityLogsInfoText';
import ConnectivityLogsAgenciesPreview from './ConnectivityLogsAgenciesPreview';
import IconButton from '../../../../../../muiComponents/IconButton';
import LoadingPlaceholder from '../../../../../../muiComponents/LoadingPlaceholder';
import { commonIcons } from '../../../../../../utils/commonVariables/commonIcons';
import ConnectivityLogsStatus from './ConnectivityLogsStatus';

interface ConnectivityLogsSummaryProps {
    handleIsPanelVisible: (bool: boolean) => void;
}

const ConnectivityLogsSummary = ({
    handleIsPanelVisible,
}: ConnectivityLogsSummaryProps) => {
    const translate = useTranslate();
    const { published, LastAgencies, agenciesCount, lastConnection } =
        useZitoneoActivityLogs();
    const [isContentVisible, setIsContentVisible] = useState(true);
    const { changeViewMode, isLoading } = useZitoneoUI();

    const goToSettings = () => {
        changeViewMode(ZitoneoViewMode.SETTINGS);
    };

    if (isLoading) {
        return (
            <div className='activity-logs-summary'>
                <LoadingPlaceholder
                    variant='rounded'
                    width='100%'
                    height={200}
                />
            </div>
        );
    }

    return (
        <div className='activity-logs-summary'>
            <div className='flex flex-between flex-align-center gap-20'>
                <div className='flex gap-10 flex-align-center'>
                    <h5 className='activity-logs-summary__overtitle'>
                        {translate('api_connectivity')}
                    </h5>
                    {isContentVisible ? (
                        ''
                    ) : (
                        <ConnectivityLogsStatus
                            published={published}
                            isVisibleText={false}
                        />
                    )}
                </div>

                <IconButton
                    iconName={
                        isContentVisible
                            ? commonIcons.ARROW_UP
                            : commonIcons.ARROW_DOWN
                    }
                    onClick={() => setIsContentVisible(visible => !visible)}
                    aria-expanded={isContentVisible}
                    size='small'
                />
            </div>
            <Collapse in={isContentVisible} timeout='auto' unmountOnExit>
                <div className='activity-logs-summary__content'>
                    <div className='flex-column gap-5'>
                        <ConnectivityLogsStatusBadge published={published} />
                        <ConnectivityLogsInfoText
                            published={published}
                            agenciesCount={agenciesCount}
                            lastConnection={lastConnection}
                            onGoToSettings={goToSettings}
                        />
                    </div>
                    {agenciesCount > 0 && (
                        <ConnectivityLogsAgenciesPreview
                            agencies={LastAgencies}
                            onOpenPanel={() => handleIsPanelVisible(true)}
                        />
                    )}
                    {agenciesCount > 0 && (
                        <div>
                            <Button
                                variant='text'
                                color='secondary'
                                startIcon={'List'}
                                onClick={() => {
                                    handleIsPanelVisible(true);
                                }}
                            >
                                {translate('show_more_info')}
                            </Button>
                        </div>
                    )}
                </div>
            </Collapse>
        </div>
    );
};

export default ConnectivityLogsSummary;
